import { type ReactNode } from 'react';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { CartDrawer } from '../cart/CartDrawer';
import { AIChatbot } from '../ai/AIChatbot';
import { OrganizationSchema } from '../SEO';
import { useFeatureEnabled } from '../../contexts/SettingsContext';
import { useAnalyticsInit } from '../../hooks/useAnalytics';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const aiChatbotEnabled = useFeatureEnabled('aiChatbotEnabled');

  // Initialize analytics (GA4, GTM, FB Pixel)
  useAnalyticsInit();

  return (
    <div className="min-h-screen flex flex-col">
      {/* Organization schema for search presence */}
      <OrganizationSchema />
      <Header />
      <Navigation />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartDrawer />
      {aiChatbotEnabled && <AIChatbot />}
    </div>
  );
}
